// extracted by mini-css-extract-plugin
module.exports = {"header":"UserApiToken_header__tBixr","textAlignCenter":"UserApiToken_textAlignCenter__1LGRN"};